import { Fragment, useState, useEffect } from 'react';
import logo from '../../images/retrohook.png';
import screenshot from '../../images/screenshot.png';
import hospital from '../../images/hospital.png';
import happy from '../../images/happy.png';
import teams from '../../images/teams.png';
import serverRoom from '../../images/secure-tunnel.png';
import cool from '../../images/cool.png';
import help from '../../images/help.png';
import cloudPatient from '../../images/cloud-patient.svg';
import PricingBox from '../components/Accounts/Elements/PricingBox';
import LoginModal from '../components/Auth/LoginModal';
import RegisterModal from '../components/Auth/RegisterModal';
import AWSRegister from '../components/Auth/AWSRegister';
import VerificationCodeModal from '../components/Auth/VerificationCodeModal';
import TermsOfServiceModal from '../components/Auth/TermsOfServiceModal';
import { Bars3Icon, XMarkIcon, DocumentTextIcon, EnvelopeIcon, PlayCircleIcon  } from '@heroicons/react/24/outline';
import { Popover, Transition } from '@headlessui/react';
import MatrixOfHL7 from '../components/Accounts/Elements/MatrixOfHL7';
import ChatwootWidget from '../components/Base/Layout/ChatWootWidget';
import AWSMarket from '../../images/aws-mkt.png';
const nav = [
  { name: 'Home', href: '#home' , current: true },
  { name: 'Features', href: '#features' },
  { name: 'Beta Pricing', href: '#pricing' },
  { name: 'Docs', href: 'https://docs.retrohook.com/' },
  { name: 'Releases', href: 'https://docs.retrohook.com/blog/' },
  { name: 'Discord', href: 'https://discord.gg/yKxwrQrwew' },
  { name: 'Youtube', href: 'https://www.youtube.com/channel/UCsgby_S_K27scdBlvvOJK8A' },
  { name: 'Contact', href: '#contact' },
];
const mainFeatures = [
  {
    id: 1,
    title: 'No-Code Integrations',
    href: 'https://docs.retrohook.com/docs/workflows',
    category: { name: 'Built for Everyone', href: 'https://docs.retrohook.com/docs/workflows' },
    imageUrl: hospital,
    preview:
      "Retrohook's workflow engine allow you to route and map legacy hl7v2 data into useful HTTPS requests (webhooks), or AWS services.",
  },
  {
    id: 2,
    title: 'Simple Secure Tunnels',
    href: 'https://docs.retrohook.com/docs/tunnels',
    category: { name: 'IPSec IKEv2 VPN', href: 'https://docs.retrohook.com/docs/tunnels' },
    imageUrl: serverRoom,
    preview:
      'Retrohook ensures secure interfaces by supporting both old and new security tech. Easily create safe MLLP tunnels with its user-friendly UI and connection agent.',
  },
  {
    id: 3,
    title: 'Private Cloud Deployments',
    href: 'https://docs.retrohook.com/docs/workspaces',
    category: { name: 'Leverage Your AWS', href: 'https://docs.retrohook.com/docs/workspaces' },
    imageUrl: happy,
    preview:
      'Deploy a Retrohook instance into your own AWS environment for enhanced compliance and security controls.',
  },
  {
    id: 4,
    title: 'Team Mode',
    href: 'https://docs.retrohook.com/docs/intro#workspaces--environments',
    category: { name: 'Shared Workspaces', href: 'https://docs.retrohook.com/docs/intro#workspaces--environments' },
    imageUrl: teams,
    preview:
      'Share your workspace and collaborate with others. Team mode also provides granular controls for managing access.',
  },
]

export default function Product(props: any) {
  const [loginModal, setLoginModal] = useState(false);
  const [registerModal, setRegisterModal] = useState(false);
  const [verificationCodeModal, setVerificationCodeModal] = useState(false);
  const [email, setEmail] = useState('');
  const [showTermsOfService, setShowTermsOfService] = useState(false);
  const [products, setProducts] = useState<any>([]);
  const [showAWSRegistrationModal, setShowAWSRegistrationModal] = useState(false);
  const [matrix, setMatrix] = useState<any>(false);
  function classNames(...classes: any) { return classes.filter(Boolean).join(" "); };
  useEffect(() => { getProducts(); }, []);
  useEffect(() => { props.mktplaceToken ? setShowAWSRegistrationModal(true) : setShowAWSRegistrationModal(false); }, [props.mktplaceToken]);

  const addPackageDetails = (product: any) => {
    switch (product.product[0].name) {
      case 'Production Plan':
        return {
          ...product,
          features: [
            'Everything in Developer +',
            'Unlimited workflows for leveraging legacy healthcare events.',
            'Unlimited team members to collaborate.',
            'Deploy Retrohook instances into your cloud infrastructure.',
            'IPSEC Tunnels for robust and secure EHR connections.',
            'Production Features - S3 Actions, FHIR R4 and more...'
          ]
        } 
      case 'Developer Plan':
        return {
          ...product,
          features: [
            'Effortless Serverless Healthcare Messaging: Experience seamless hl7v2 communication without the complexities of server management',
            'Test Workflows: Design and test up to 5 non-PHI workflows, perfect for experimentation and learning.',
            'Shared Developer Workspace: Collaborate effectively with a 3-seat workspace designed for dynamic development teams.',
            'Message Allocation: Benefit from 100 messages per month, allowing for ample testing and development.',
            'Community Support: Gain insights and assistance from a community that understands your development needs.'
          ]
      };
      default:
        return {}
    }
  };
  const getProductsJSON = async () => {
    return {
      "data": [
        {
            "id": "price_1LOCsQKCFwpQCzl3J5KmLZN7",
            "object": "price",
            "active": true,
            "billing_scheme": "per_unit",
            "created": 1658461810,
            "currency": "usd",
            "custom_unit_amount": null,
            "livemode": false,
            "lookup_key": null,
            "metadata": {},
            "nickname": null,
            "product": [
                {
                    "id": "prod_M60OTkntKj1Nxq",
                    "object": "product",
                    "active": true,
                    "attributes": [],
                    "created": 1658367664,
                    "default_price": "price_1LNoNxKCFwpQCzl3CLSELQcS",
                    "description": null,
                    "features": [],
                    "images": [],
                    "livemode": false,
                    "metadata": {},
                    "name": "Developer Plan",
                    "package_dimensions": null,
                    "shippable": null,
                    "statement_descriptor": null,
                    "tax_code": "txcd_10103001",
                    "type": "service",
                    "unit_label": null,
                    "updated": 1658461811,
                    "url": null
                }
            ],
            "recurring": {
                "aggregate_usage": null,
                "interval": "year",
                "interval_count": 1,
                "trial_period_days": null,
                "usage_type": "licensed"
            },
            "tax_behavior": "exclusive",
            "tiers_mode": null,
            "transform_quantity": null,
            "type": "recurring",
            "unit_amount": 0,
            "unit_amount_decimal": "0"
        },
        {
            "id": "price_1LOC37KCFwpQCzl3fkBFnwll",
            "object": "price",
            "active": true,
            "billing_scheme": "per_unit",
            "created": 1658458629,
            "currency": "usd",
            "custom_unit_amount": null,
            "livemode": false,
            "lookup_key": null,
            "metadata": {},
            "nickname": null,
            "product": [
                {
                    "id": "prod_M60PZr5qZsMtCZ",
                    "object": "product",
                    "active": true,
                    "attributes": [],
                    "created": 1658367710,
                    "default_price": "price_1LNoOhKCFwpQCzl3UttinsyD",
                    "description": null,
                    "features": [],
                    "images": [],
                    "livemode": false,
                    "metadata": {},
                    "name": "Production Plan",
                    "package_dimensions": null,
                    "shippable": null,
                    "statement_descriptor": null,
                    "tax_code": "txcd_10103001",
                    "type": "service",
                    "unit_label": null,
                    "updated": 1658458630,
                    "url": null
                }
            ],
            "recurring": {
                "aggregate_usage": null,
                "interval": "year",
                "interval_count": 1,
                "trial_period_days": null,
                "usage_type": "licensed"
            },
            "tax_behavior": "exclusive",
            "tiers_mode": null,
            "transform_quantity": null,
            "type": "recurring",
            "unit_amount": 10900000,
            "unit_amount_decimal": "10900000"
        },
        {
            "id": "price_1LNoOhKCFwpQCzl3UttinsyD",
            "object": "price",
            "active": true,
            "billing_scheme": "per_unit",
            "created": 1658367711,
            "currency": "usd",
            "custom_unit_amount": null,
            "livemode": false,
            "lookup_key": null,
            "metadata": {},
            "nickname": null,
            "product": [
                {
                    "id": "prod_M60PZr5qZsMtCZ",
                    "object": "product",
                    "active": true,
                    "attributes": [],
                    "created": 1658367710,
                    "default_price": "price_1LNoOhKCFwpQCzl3UttinsyD",
                    "description": null,
                    "features": [],
                    "images": [],
                    "livemode": false,
                    "metadata": {},
                    "name": "Production Plan",
                    "package_dimensions": null,
                    "shippable": null,
                    "statement_descriptor": null,
                    "tax_code": "txcd_10103001",
                    "type": "service",
                    "unit_label": null,
                    "updated": 1658458630,
                    "url": null
                }
            ],
            "recurring": {
                "aggregate_usage": null,
                "interval": "month",
                "interval_count": 1,
                "trial_period_days": null,
                "usage_type": "licensed"
            },
            "tax_behavior": "exclusive",
            "tiers_mode": null,
            "transform_quantity": null,
            "type": "recurring",
            "unit_amount": 500000,
            "unit_amount_decimal": "1000000"
        },
        {
            "id": "price_1LNoNxKCFwpQCzl3CLSELQcS",
            "object": "price",
            "active": true,
            "billing_scheme": "per_unit",
            "created": 1658367665,
            "currency": "usd",
            "custom_unit_amount": null,
            "livemode": false,
            "lookup_key": null,
            "metadata": {},
            "nickname": null,
            "product": [
                {
                    "id": "prod_M60OTkntKj1Nxq",
                    "object": "product",
                    "active": true,
                    "attributes": [],
                    "created": 1658367664,
                    "default_price": "price_1LNoNxKCFwpQCzl3CLSELQcS",
                    "description": null,
                    "features": [],
                    "images": [],
                    "livemode": false,
                    "metadata": {},
                    "name": "Developer Plan",
                    "package_dimensions": null,
                    "shippable": null,
                    "statement_descriptor": null,
                    "tax_code": "txcd_10103001",
                    "type": "service",
                    "unit_label": null,
                    "updated": 1658461811,
                    "url": null
                }
            ],
            "recurring": {
                "aggregate_usage": null,
                "interval": "month",
                "interval_count": 1,
                "trial_period_days": null,
                "usage_type": "licensed"
            },
            "tax_behavior": "exclusive",
            "tiers_mode": null,
            "transform_quantity": null,
            "type": "recurring",
            "unit_amount": 0,
            "unit_amount_decimal": "0"
        }
      ]
    };
  };
  const getProducts = async () => {
    try {
      const productItems: any = await getProductsJSON();
      if (productItems?.data) {
        const products = productItems.data.map((product: any) => addPackageDetails(product));
        setProducts(products.sort((a: any, b: any) => (a.unit_amount > b.unit_amount) ? 1 : -1));
      }
    } catch (error) {
      console.error("Failed to fetch products:", error);
    }
  };
  const matrixCSS = '';
  if (props?.user) {
    return (
      <div className="flex flex-col justify-center items-center animate-color-change-2x h-screen">
        <div className="items-center animate-pulse">
          <img className="h-24 mx-auto w-auto" src={logo} alt="Logo"/>
          <h2 className="mt-0 text-center text-2xl font-bold text-gray-200">Retrohook
            <span className="inline align-middle text-xs tracking-tight text-cyan-300 pl-1"></span>
          </h2>
        </div>
      </div>
    );
  }
  return (
    <main>
      <ChatwootWidget />
      { showAWSRegistrationModal && 
      <AWSRegister 
        mktplaceToken={props.mktplaceToken}
        setNavHighlight={props.setNavHighlight} 
        setEmail={setEmail}
        open={showAWSRegistrationModal} 
        setVerificationCodeModel = {() => { setVerificationCodeModal(true); }} 
        closeModal={() => { setShowAWSRegistrationModal(false); setMatrix(!matrix); }} 
      />
      }
      { showTermsOfService && 
        <TermsOfServiceModal 
          open={showTermsOfService} 
          closeModal={() => { setShowTermsOfService(false); setMatrix(!matrix); }} 
        /> 
      }
      { loginModal && 
        <LoginModal 
          setNavHighlight={props.setNavHighlight} 
          open={ loginModal } 
          setRegisterModal={() => { setLoginModal(false); setRegisterModal(true); }} 
          closeModal={ () => { setLoginModal(false); setMatrix(!matrix); }} 
        /> 
      }
      { registerModal && 
        <RegisterModal 
          open={registerModal} 
          setSignInModal={() => { setRegisterModal(false); setLoginModal(true); }} 
          closeRegisterModal={ () => { setRegisterModal(false); }} 
          setEmail={setEmail} 
          setVerificationCodeModel = {() => { setVerificationCodeModal(true); }} 
          closeModal={ () => { setRegisterModal(false); setMatrix(!matrix); }} 
        /> 
      }
      { verificationCodeModal && 
        <VerificationCodeModal 
          open={verificationCodeModal} 
          email={email} setSignInModal={() => { setVerificationCodeModal(false); setLoginModal(true); }} 
          closeModal={ () => { setVerificationCodeModal(false); setMatrix(!matrix); }} 
        /> 
      }
      <Popover as="header" className="sticky animate-color-change-2x top-0 z-10 border-b-2 border-cyan-400 shadow-2xl">
        <div className="animate-color-change-2x py-2">
          <nav className="mx-auto flex items-center justify-between sm:pl-3" aria-label="Global">
              <div className="flex items-center flex-1">
                <div className="flex items-center justify-between w-full md:w-auto">
                <button>    
                  <img className="h-8 inline px-1" src={logo} alt="logo" />                
                  <span className="inline align-middle text-xl font-semibold text-gray-200 pl-1">Retrohook</span>
                  <span className="inline text-xs text-cyan-300 pl-2"></span>
                </button>
                  <div className="mr-4 flex items-center md:hidden">
                    <Popover.Button className="bg-gray-700 rounded-md p-2 inline-flex items-center justify-center text-gray-100 hover:bg-cyan-800 focus:outline-none focus:ring-2 focus-ring-inset focus:ring-white">
                      <span className="sr-only">Open main menu</span>
                      <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                    </Popover.Button>
                  </div>
                </div>
                <div className="hidden space-x-8 md:flex md:ml-10">
                  {nav.map((item: any) => (
                    <a className="text-base font-medium text-white hover:text-gray-300" key={item.name} href={item.href}>
                      {item.name}
                    </a>
                  ))}
                </div>
              </div>
            <div className="hidden md:flex pr-4">
              <a onClick={ () => { setLoginModal(true); setMatrix(!matrix); }} className="px-2 py-1 cursor-pointer border border-solid border-cyan-300 hover:border-gray-50 text-sm font-medium rounded-md text-cyan-600 bg-gray-100 hover:bg-gray-100">
                  Log in
              </a>
              </div>
          </nav>
        </div>
        <Transition as={Fragment} enter="duration-150 ease-out" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="duration-100 ease-in" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
          <Popover.Panel focus className="absolute animate-color-change-2x top-0 inset-x-0 p-2 transition transform origin-top md:hidden">
            <div className="rounded-lg px-6 shadow-md animate-color-change-2x ring-1 ring-black ring-opacity-5 overflow-hidden">
              <div className="px-5 pt-4 flex items-center justify-between">
                <div>
                  <button>    
                    <img className="h-10 inline px-1 shadow-sm" src={logo} alt="logo" />                
                    <span className="inline align-middle text-2xl tracking-tight font-bold text-gray-100 shadow- pl-1">Retrohook</span>
                  </button>
                </div>
                <div className="-mr-2">
                  <Popover.Button className=" rounded-md p-2 inline-flex items-center justify-center text-gray-50 hover:bg-pink-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cyan-600">
                    <span className="sr-only">Close menu</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                </div>
              </div>
              <div className="pt-5 pb-6">
                <div className="px-2 space-y-1">
                  {nav.map((item: any) => (<a key={item.name} href={item.href} className="block px-3 py-2 rounded-md text-base font-medium text-gray-50 hover:bg-gray-500">{item.name}</a>))}
                </div>
                <div className="mt-6 px-5">
                  <button onClick={ () => { setRegisterModal(true); setMatrix(!matrix); }} className="text-center w-full py-3 px-4 rounded-md shadow bg-gradient-to-r from-cyan-400 to-cyan-500 text-white cursor-pointer font-medium hover:from-cyan-500 hover:to-cyan-600">
                    Sign Up Free!
                  </button>
                  <button onClick={ () => { setRegisterModal(true); setMatrix(!matrix); }} className="text-center w-full py-3 px-4 mt-2 rounded-md shadow bg-gradient-to-r from-pink-400 to-pink-500 text-white cursor-pointer font-medium hover:from-pink-500 hover:to-pink-600">
                   <img className="inline h-6" src={AWSMarket} alt="AWS Marketplace" />
                  </button>
                </div>
                <div className="mt-6 px-5">
                  <p className="text-center text-base font-medium text-gray-500">Existing customer?{' '}<a onClick={ () => { setLoginModal(true); setMatrix(!matrix); }} className="text-pink-400 cursor-pointer hover:underline">Login</a></p>
                </div>
              </div>
            </div>
          </Popover.Panel>
        </Transition>
      </Popover> 
      <div id="home" className="pt-10 sm:pt-16 lg:pt-8 lg:pb-14 lg:overflow-hidden">
        <div className="mx-auto px-8">
          <div className="grid grid-cols-2 gap-2">
            <div className="mx-auto px-4 sm:max-w-2xl sm:px-6 sm:text-center lg:px-0 lg:text-left lg:flex lg:items-center">
              <div className="lg:py-24">
                <h1 className={classNames(matrix ? matrixCSS : '', 'mt-4 text-4xl tracking-tight font-bold text-white sm:mt-5 sm:text-xl sm:tracking-tight lg:mt-6 md:text-4xl lg:text-5xl xl:text-5xl xl:tracking-tight')}>
                  <span className="block">Instant Integration</span>
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-gray-200 to-pink-600">Infinite Innovation</span>
                </h1>
                <p className={classNames(matrix ? matrixCSS : '', "text-base text-gray-300 sm:text-xl lg:text-lg xl:text-xl")}>Empower your product with seamless, secure hl7 exchange.</p>
                <div className="mt-4">
                  <form action="#" className="sm:max-w-2xl sm:mx-auto lg:mx-0">
                    <div className="w-full">
                      <div className="sm:mt-0 sm:ml-3">
                        <a type="button"
                          href="#"
                          onClick={() => { setRegisterModal(true); setMatrix(!matrix); }}
                          className="inline py-1.5 px-2 rounded-md shadow bg-cyan-400  text-white font-medium hover:bg-cyan-500 border-2 border-cyan-500">
                          Create Free Account!
                        </a>
                        <a type="button"
                          href="https://aws.amazon.com/marketplace/pp/prodview-efbfzy3xjgx5s"
                          className="inline ml-4 py-2 px-4 rounded-md text-sm border-2 border-transparent text-white font-medium hover:border-pink-500">
                          Find us on<img className="inline h-5 pl-2" src={AWSMarket} alt="AWS Marketplace" />
                        </a>
                      </div>
                    </div>
                    <p className="mt-6 text-sm text-gray-300 sm:mt-4">Get your free account, no credit card necessary. By signing up, you agree to our{' '}<a onClick={() => { setShowTermsOfService(!showTermsOfService); setMatrix(!matrix); }} className="font-medium text-white">terms of service</a>.</p>
                  </form>
                </div>
              </div>
            </div>
            <div className="mt-12 -mb-16 lg:m-0 lg:relative">
              <div className="mx-auto px-4 sm:max-w-2xl sm:px-6 lg:max-w-none lg:px-0">
                <img 
                  className="w-full cursor-pointer lg:absolute lg:inset-y-0 lg:left-0 lg:h-full lg:w-auto lg:max-w-none" 
                  src={cloudPatient} 
                  alt="data UP UP" 
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="overview" className="relative pt-6 bg-gradient-to-b from-transparent to-gray-800">
        <div className="mx-auto max-w-md px-4 text-center  sm:px-6 sm:max-w-3xl lg:px-8 lg:max-w-7xl">
          <div className={classNames(matrix ? matrixCSS : '', 'mx-auto')}>
            <h2 className="text-xl font-semibold text-cyan-300">⚡️ Power Up Your AWS With EHR Data ⚡️</h2>
            <p className="mt-2 text-3xl font-bold text-gray-200 tracking-tight sm:text-4xl sm:tracking-tight">
              🔥 Reignite HL7v2.x With Clicks, Not Code.
            </p>
            <p className="mt-2 max-w-prose mx-auto text-xl text-gray-400">
              Quickly and securely connect EHR data to modern technologies you ❤️. Retrohook provides a no-code experience for HL7 v2.x messaging, allowing you to focus on your product and not the plumbing.
            </p>
          </div>
          <div className="mt-12 -mb-10 sm:-mb-24 lg:-mb-80">
            <img className="rounded-lg shadow-xl ring-1 ring-black ring-opacity-5" src={screenshot} alt="A view of Retrohook" />
          </div>
        </div>
      </div>
      <div id="features" className="relative bg-gradient-to-b from-gray-800 to-gray-700">
      { matrix ? <MatrixOfHL7 /> : null }   
        <div className="relative items-center">
        <div className=' py-8 mb-16'>
            <div className="text-center mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
              <h2 className="text-lg font-semibold text-cyan-600">Learn more about how</h2>
              <p className="mt-2 text-3xl font-bold text-gray-200 tracking-tight sm:text-4xl sm:tracking-tight">Retrohook Accelerates HL7v2 Integration</p>
              <p className="my-5 mx-auto max-w-prose text-xl text-gray-500">
              Retrohook takes care of the heavy lifting by providing a no-code experience for working with HL7v2.x based integrations, the modules below work together to provide a seamless experience for your team and customers. 
              </p>
            </div>
            <div className="mx-auto px-4 grid gap-8 sm:px-6 lg:px-8 sm:grid-cols-1 grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 max-w-7xl">
              {mainFeatures.map((post) => (
                <div key={post.id} className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:animate-pulse hover:ring-2 hover:ring-cyan-300 cursor-pointer">
                  <div className="flex-shrink-0"><img className="h-48 w-full object-cover" src={post.imageUrl} alt="" /></div>
                  <div className="flex-1 p-6 flex flex-col justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-cyan-400"><a href={post.category.href}  className="hover:underline">{post.category.name}</a></p>
                      <a href={post.href}  className="block mt-2">
                        <p className="text-xl font-semibold text-gray-200">{post.title}</p>
                        <p className="mt-3 text-base text-gray-400">{post.preview}</p>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
              </div>
          </div>
          <div className="bg-cyan-500 bg-gradient-to-r from-cyan-300 lg:z-10">
            <div className="lg:mx-auto lg:max-w-7xl lg:px-8 grid grid-cols-3 lg:grid lg:grid-cols-3 lg:gap-8">
              <div className="lg:-mt-28 md:-mt-14 mt-32">
                <div className="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:p-0 lg:h-full">
                  <div className="aspect-w-10 aspect-h-10 rounded-xl overflow-hidden sm:aspect-w-7 sm:aspect-h-7 lg:aspect-none lg:h-full">
                    <img className="max-h-96 sm:max-h-84 md:max-h-84" src={cool} alt="" />
                  </div>
                </div>
              </div>
              <div className="lg:m-0 col-span-2 lg:pl-8">
                <div className="mx-auto max-w-md px-4 sm:max-w-2xl sm:px-6 lg:px-0 mt-8 lg:max-w-none">
                  <blockquote>
                    <div>
                      <svg className="h-6 w-6 text-white opacity-25" fill="currentColor" viewBox="0 0 32 32" aria-hidden="true">
                        <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                      </svg>
                      <p className="mt-4 sm:text-sm md:text-lg lg:text-2xl xl:text-2xl font-medium text-white">Taking advantage of the immense power of HL7 v2.x's event driven messaging does not have to be difficult.  With Retrohook, our abstractions provide your team and customers rapid time to value.</p>
                    </div>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="pricing">
        <div className="relative items-center">
        <div className=' py-8'>
            <div className="text-center mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
              <h2 className="text-lg font-semibold text-cyan-600">Simple Pricing</h2>
              <PricingBox 
                setRegisterModal={setRegisterModal}
                products={products}
              />
            </div>
          </div>
        </div>
      </div>
      <div id="contact">
        <div className="relative md:absolute md:left-0 md:w-1/2">
          <img className=" object-cover" src={help} alt="Retrohook takes you back in time" />
          <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-r from-gray-300 to-gray-400 mix-blend-multiply"/>
        </div>
        <div className="relative mx-auto max-w-md px-4 pt-6 sm:max-w-7xl sm:px-6">
          <div className="md:ml-auto md:w-1/2 md:pl-10">
            <div className={classNames(matrix ? 'px-12 py-4 m-2 bg-gray-700 border-2 border-gray-600 shadow-xl rounded' : '', 'cursor-pointer')}>
              <h2 className="text-lg font-semibold text-cyan-300">Visit Our Product Guide</h2>
              <p className="mt-2 text-white text-3xl font-bold tracking-tight sm:text-4xl sm:tracking-tight">Get started with Retrohook today</p>
              <p className="mt-3 text-lg text-gray-300">Check out our documentation to learn how to get started with Retrohook. When you are ready we are here to help.</p>
              <div className="my-8">
                <div className="inline-flex rounded-md shadow">
                  <a href="https://docs.retrohook.com/"  className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-100 bg-pink-400 hover:bg-pink-500" >
                  <DocumentTextIcon className="-ml-1 mr-1 h-5 w-5 text-gray-100" aria-hidden="true" />
                    Docs
                  </a>
                </div>
                <div className="inline-flex rounded-md shadow pl-4">
                  <a href="https://www.youtube.com/channel/UCsgby_S_K27scdBlvvOJK8A"  className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-100 bg-cyan-400 hover:bg-cyan-500" >
                  <PlayCircleIcon className="-ml-1 mr-1 h-5 w-5 text-gray-100" aria-hidden="true" />
                    Youtube
                  </a>
                </div>
                <div className="inline-flex ml-4 rounded-md shadow">
                  <a href="mailto:sales@retrohook.com" className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-100 bg-gray-400 hover:bg-gray-500" >
                  <EnvelopeIcon className="-ml-1 mr-1 h-5 w-5 text-gray-100" aria-hidden="true" />
                    Request Info
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}
